import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export const deleteEmployee = async (id: string) => {
  try {
    const response = await axiosInstance.delete(
      `${config.apiUrl}/auth/delete-employee/${id}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Error deleting employee"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
};
